
import { Component, Emit, ModelSync, Prop, Vue, } from 'vue-property-decorator';
import { BrandColoursType, isBrandColour, } from '~/utils/resources';

@Component
export default class SearchBar extends Vue {
	@Prop({
		type: String,
		required: true,
		validator(value) {
			return isBrandColour(value);
		},
	})
	colour!: BrandColoursType;

	@Prop({
		type: Boolean,
		required: false,
		default: false,
	})
	compact!: boolean;

	@Prop({
		type: String,
		required: true,
	})
	formAction!: string;

	@Prop({
		type: Array,
		required: false,
	})
	hiddenInputs!: readonly { name: string, value: string, }[];

	@Prop({
		type: String,
		default: 'Enter a search term',
		required: false,
	})
	label!: string;

	@Prop({
		type: String,
		required: true,
	})
	placeholder!: string;

	@Prop({
		type: String,
		required: false,
		default: 'q',
	})
	searchParameter!: string;

	@Prop({
		type: Boolean,
		required: false,
		default: false,
	})
	stretched!: boolean;

	@Prop({
		type: String,
		required: false,
		validator(value) {
			return isBrandColour(value);
		},
	})
	textColour!: BrandColoursType;

	get hasSubmitListener() {
		return this.$listeners && this.$listeners.submit;
	}

	@ModelSync('input', 'change', { type: String, })
	readonly searchValue!: string;

	@Emit('submit')
	onSubmit(e: Event) {
		if (this.hasSubmitListener) {
			e.preventDefault();
		}
		console.warn('submit in bar');
	}
}
